import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

const InputCheckbox = ({ children, onChange, required, name, checked }) => {
  const handleOnChange = (e) => onChange(e.target);

  return (
    <label className="checkbox-label">
      <input
        type="checkbox"
        name={name}
        className="checkboxInput"
        onChange={handleOnChange}
        required={required}
        checked={checked}
      />
      <span>{children}</span>
    </label>
  );
};

InputCheckbox.propTypes = {
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  required: PropTypes.bool,
  name: PropTypes.string,
  checked: PropTypes.bool,
};

InputCheckbox.defaultProps = {
  children: null,
  onChange: () => {},
  required: false,
  name: '',
  checked: false,
};
export default InputCheckbox;
